import { ButtonHTMLAttributes, FC, HTMLAttributes } from 'react';

import cx from 'classnames';

export interface TabsProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  normalClass?: string;
  activeClass?: string;
  tabs: { label: string }[];
  btnProps?: ButtonHTMLAttributes<HTMLButtonElement>;
  value?: number;
  onChange?(value: number): any;
}

const Tabs: FC<TabsProps> = ({
  tabs = [],
  value,
  onChange,
  normalClass = 'shadow-xl bg-dark-blue-100 text-white',
  activeClass = 'bg-white text-dark-blue-100 shadow-[0_10px_45px_4px_rgb(0,0,0,0.1)]',
  className,
  btnProps,
  ...props
}) => {
  return (
    <div {...props} className={cx('flex -mx-1', className)}>
      {tabs.map((tab, index) => (
        <button
          {...btnProps}
          onClick={() => onChange && onChange(index)}
          className={cx(
            'flex-grow px-3 py-2 mx-[2px] rounded-tl-md rounded-tr-md basis-0 transition-colors relative',
            btnProps?.className,
            {
              [normalClass]: index !== value,
              [activeClass]: index === value,
            },
          )}
          key={tab.label}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
